import angular from 'angular';
import template from './template.html';
import './style.scss';

export class CandidateDetailsSection {
    /* @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    $onChanges() {
        this.$scope.candidate = this.candidate;
    }
}

export const CandidateDetailsSectionConfig = {
    template,
    bindings: {
        candidate: '<'
    },
    controller: CandidateDetailsSection,
    controllerAs: 'candidateDetailsSectionCtrl'
};

angular.module('TALENYA-FE').component('candidateDetailsSection', CandidateDetailsSectionConfig);
